export const YOUR_ACCOUNT_REQUEST = 'YOUR_ACCOUNT_REQUEST';
export const SUCCESS_YOUR_ACCOUNT_REQUEST = 'SUCCESS_YOUR_ACCOUNT_REQUEST';
export const FAILURE_YOUR_ACCOUNT_REQUEST = 'FAILURE_YOUR_ACCOUNT_REQUEST';
export const UPDATE_CONTACT_INFO_REQUEST = 'UPDATE_CONTACT_INFO_REQUEST';
export const SUCCESS_UPDATE_CONTACT_INFO_REQUEST = 'SUCCESS_UPDATE_CONTACT_INFO_REQUEST';
export const FAILURE_UPDATE_CONTACT_INFO_REQUEST = 'FAILURE_UPDATE_CONTACT_INFO_REQUEST';
export const RESET_EDIT_CONTACT_INFO_FLAGS = 'RESET_EDIT_CONTACT_INFO_FLAGS';
export const UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST = 'UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST';
export const SUCCESS_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST = 'SUCCESS_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST';
export const FAILURE_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST = 'FAILURE_UPDATE_SECURITY_QUESTION_ANSWERS_REQUEST';
export const RESET_CHANGE_SECURITY_QUESTION_ANSWERS_FLAGS = 'RESET_CHANGE_SECURITY_QUESTION_ANSWERS_FLAGS';
export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const SUCCESS_UPDATE_PASSWORD_REQUEST = 'SUCCESS_UPDATE_PASSWORD_REQUEST';
export const FAILURE_UPDATE_PASSWORD_REQUEST = 'FAILURE_UPDATE_PASSWORD_REQUEST';
export const RESET_CHANGE_PASSWORD_FLAGS = 'RESET_CHANGE_PASSWORD_FLAGS';
export const GET_EMAIL_PREFERENCES = 'GET_EMAIL_PREFERENCES';
export const GET_EMAIL_PREFERENCES_SUCCESS = 'GET_EMAIL_PREFERENCES_SUCCESS';
export const GET_EMAIL_PREFERENCES_FAILURE = 'GET_EMAIL_PREFERENCES_FAILURE';
export const SAVE_EMAIL_PREFERENCES = 'SAVE_EMAIL_PREFERENCES';
export const SAVE_EMAIL_PREFERENCES_SUCCESS = 'SAVE_EMAIL_PREFERENCES_SUCCESS';
export const SAVE_EMAIL_PREFERENCES_FAILURE = 'SAVE_EMAIL_PREFERENCES_FAILURE';
export const CHANGE_YOUR_ACCOUNT_VIEW = 'CHANGE_YOUR_ACCOUNT_VIEW';
export const UPDATE_DATA_ENTRY = 'UPDATE_DATA_ENTRY';
export const TOGGLE_CAN_UPDATE_CONTACT_INFO = 'TOGGLE_CAN_UPDATE_CONTACT_INFO';
export const RESET_YOUR_ACCOUNT_DATA_REQUEST = 'RESET_YOUR_ACCOUNT_DATA_REQUEST';
export const RESET_YOUR_ACCOUNT_CONTACT_INFO_REQUEST = 'RESET_YOUR_ACCOUNT_CONTACT_INFO_REQUEST';
export const RESET_YOUR_ACCOUNT_SECURITY_QUESTIONS_REQUEST = 'RESET_YOUR_ACCOUNT_SECURITY_QUESTIONS_REQUEST';
export const TOGGLE_YOUR_ACCOUNT_SHOW_VIEW = 'TOGGLE_YOUR_ACCOUNT_SHOW_VIEW';
export const RESET_YOUR_ACCOUNT_PASSWORD_UPDATE_REQUEST = 'RESET_YOUR_ACCOUNT_PASSWORD_UPDATE_REQUEST';
export const UPDATE_EMAIL_CHECKBOX = 'UPDATE_EMAIL_CHECKBOX';
export const RESET_YOUR_ACCOUNT_VIEW = 'RESET_YOUR_ACCOUNT_VIEW';
export const RESET_EMAIL_PREFERENCES_UPDATE = 'RESET_EMAIL_PREFERENCES_UPDATE';
